import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/index.css";
import App from "./App";
import { CurrentPageProvider } from "./contexts/currentPage";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <CurrentPageProvider>
      <App />
    </CurrentPageProvider>
);
